export interface AdobeLaunchState {
  TrackProcessStartCalled: boolean;
}
